import { network } from 'services/network';

export const createOrUpdateCardComment = (params) => {
    return network.post('api/bo/createOrUpdateCardComment', params).then((response) => {
        return response.data;
    });
};
